import { deleteRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function getTripByIdRequest(id) {
	let url = subOrders.getByIdPath(id);
	let response = await deleteRequest(url);
	return response;
}